import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jpassarg(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
   <Sides/>
   <Helmet>
 
  <title>Java passing arguments tutorial For Beginners</title>
<meta name="description" content="Java passing arguments tutorial for beginners.An argument may be a variable as a constant value that is used in the () of function." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java passing argument,passing argument in java,passing command line arguments in java,java argument passing example,argument passing in java with example,passing argument with java,java variable arguments pass list,java jar pass arguments command line,java passing arguments,java passing hashmap as argument
,java passing date parameter to stored procedure,java passing arguments to batch file,java passing parameters cmd,java pass arguments to jar file,java pass arguments as array,java pass arguments to run method,java passing optional arguments" />
<link rel="canonical" href="https://www.codeexampler.com/java-passing-argument" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Passing argument in java</h1>
    <div className="first">
        <a href="/java-overriding">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-enum">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para ">An argument may be a variable as a constant value that is used in the () of function.</p>

  

<h2 className="headings">Q-Write a Program Example of the namespace in Java?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> A</span>
          {"\n"}
          <span className="qwerty-3"> &#123; </span>
          {"\n"}
          <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">argument </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-10">int </span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-1">) </span>
          <span className="qwerty-2">{`// int n is a formal argument`}</span>  
          {"\n"}
          <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
          {"\n"}
    
            <span className="qwerty-10">&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">"my no is " </span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-1">);</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
          {"\n"}
                     
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-10">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-9">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
          {"\n"} 
    
          <span className="qwerty-10">&nbsp; &nbsp; &nbsp;int </span>
          <span className="qwerty-4">n </span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-9"> 20; </span>
          {"\n"} 
          <span className="qwerty-8">&nbsp; &nbsp; &nbsp;argument </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-1">); </span>
          <span className="qwerty-2">{`// n is a actual argument`}</span>  
          {"\n"} 
          <span className="qwerty-3">&nbsp; &nbsp; &#125; </span>
          {"\n"} 
    
    
    
    
    
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-9">&nbsp; 20</span>
          {"\n"}
            </code>{"\n"}{"   "}
            </pre>
      </div>
    </div>
    <div>
      <h3 className="headings">Answer</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-9">&nbsp; my no is 20</span>
          {"\n"}
            </code>{"\n"}{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Q-Write a Program to check a no is even or odd by using passing argument?</h2>
<div
  style={{
    background: "#0f0e33",
    width: "94%",
    marginLeft: "3%",
    paddingLeft: "2%",
    borderRadius: "20px",
  }}
>
  <pre style={{ maxHeight: "500vh" }}>
    <code>
      {"\n"}
      <span className="qwerty-7">public </span>
      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> A</span>
      {"\n"}
      <span className="qwerty-3"> &#123; </span>
      {"\n"}
      <span className="qwerty-7">&nbsp; &nbsp;public </span>
      <span className="qwerty">static </span>
      <span className="qwerty-3">void </span>
      <span className="qwerty-8">check </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">int </span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-1">) </span>
      <span className="qwerty-2">{`//(int i) is a formal argument`}</span>  
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
      {"\n"}




      <span className="qwerty-9">&nbsp; &nbsp; &nbsp; if</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
        <span className="qwerty-8">%</span>
        <span className="qwerty-4">2</span>
        <span className="qwerty-8">==</span>
        <span className="qwerty-4">0</span>
        <span className="qwerty-1">)</span>
      {"\n"}
        <span className="qwerty-3">&nbsp; &nbsp;&nbsp; &nbsp; &#123; </span>
        {"\n"}
        <span className="qwerty-10">&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"even no"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp;&nbsp; &nbsp; &#125; </span>
      {"\n"}
      <span className="qwerty-9">&nbsp; &nbsp; &nbsp; else</span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp;&nbsp; &nbsp; &#123; </span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"odd no"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp;&nbsp; &nbsp; &#125; </span>
      {"\n"}
        <span className="qwerty-3"> &nbsp; &nbsp; &#125; </span>
        {"\n"}
       
        <span className="qwerty-7">&nbsp; &nbsp;public </span>
      <span className="qwerty">static </span>
      <span className="qwerty-3">void </span>
      <span className="qwerty-8">main </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">String</span>
      <span className="qwerty-1">[] </span>
      <span className="qwerty-9">args</span>
      <span className="qwerty-1">) </span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
      {"\n"} 

      <span className="qwerty-10">&nbsp; &nbsp; &nbsp;int </span>
      <span className="qwerty-4">a </span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-9"> 40; </span>
      {"\n"} 
      <span className="qwerty-8">&nbsp; &nbsp; &nbsp;check </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">); </span>
      <span className="qwerty-2">{`// a is a actual argument`}</span>  
      {"\n"} 
      <span className="qwerty-3">&nbsp; &nbsp; &#125; </span>
      {"\n"} 





      <span className="qwerty-3">&#125; </span>
        {"\n"}





   
    </code>
  </pre>        
</div>

<div>
  <h3 className="headings">Output</h3>
  <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
    <pre style={{ maxHeight: '500vh' }}>
      <code className="python hljs">
      {"\n"}
      <span className="qwerty-9">&nbsp; 40</span>
      {"\n"}
        </code>{"\n"}{"   "}
        </pre>
  </div>
</div>
<div>
  <h3 className="headings">Answer</h3>
  <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
    <pre style={{ maxHeight: '500vh' }}>
      <code className="python hljs">
      {"\n"}
      <span className="qwerty-9">&nbsp; even no</span>
      {"\n"}
        </code>{"\n"}{"   "}
        </pre>
  </div>
</div>




<h2 className="headings">Q-Write a Program check greater no by using function?</h2>
<div
  style={{
    background: "#0f0e33",
    width: "94%",
    marginLeft: "3%",
    paddingLeft: "2%",
    borderRadius: "20px",
  }}
>
  <pre style={{ maxHeight: "500vh" }}>
    <code>
      {"\n"}
      <span className="qwerty-7">public </span>
      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> A</span>
      {"\n"}
      <span className="qwerty-3"> &#123; </span>
      {"\n"}
      <span className="qwerty-7">&nbsp; &nbsp;public </span>
      <span className="qwerty">static </span>
      <span className="qwerty-3">void </span>
      <span className="qwerty-8">maximum </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">int </span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-8"> , </span>
      <span className="qwerty-10">int </span>
      <span className="qwerty-4">b</span>
      <span className="qwerty-1">) </span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
      {"\n"}




      <span className="qwerty-9">&nbsp; &nbsp; &nbsp; if</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
        <span className="qwerty-8">&#62;</span>
        <span className="qwerty-4">b</span>
        <span className="qwerty-1">)</span>
      {"\n"}
        <span className="qwerty-3">&nbsp; &nbsp;&nbsp; &nbsp; &#123; </span>
        {"\n"}
        <span className="qwerty-10">&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"maximum="</span>
      <span className="qwerty-8">+</span>
          <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp;&nbsp; &nbsp; &#125; </span>
      {"\n"}
      <span className="qwerty-9">&nbsp; &nbsp; &nbsp; else</span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp;&nbsp; &nbsp; &#123; </span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"maximum="</span>
      <span className="qwerty-8">+</span>
          <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp;&nbsp; &nbsp; &#125; </span>
      {"\n"}
        <span className="qwerty-3"> &nbsp; &nbsp; &#125; </span>
        {"\n"}
       
        <span className="qwerty-7">&nbsp; &nbsp;public </span>
      <span className="qwerty">static </span>
      <span className="qwerty-3">void </span>
      <span className="qwerty-8">main </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">String</span>
      <span className="qwerty-1">[] </span>
      <span className="qwerty-9">args</span>
      <span className="qwerty-1">) </span>
      {"\n"}
      <span className="qwerty-3">&nbsp; &nbsp; &#123; </span>
      {"\n"} 

      <span className="qwerty-10">&nbsp; &nbsp; &nbsp;int </span>
      <span className="qwerty-4">x </span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-9"> 40 </span>
      <span className="qwerty-8"> , </span>
      <span className="qwerty-4">y </span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-9"> 65; </span>
      {"\n"} 
      <span className="qwerty-8">&nbsp; &nbsp; &nbsp;maximum </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">x</span>
      <span className="qwerty-8"> , </span>
      <span className="qwerty-4">y</span>
      <span className="qwerty-1">); </span>
      {"\n"} 
      <span className="qwerty-3">&nbsp; &nbsp; &#125; </span>
      {"\n"} 





      <span className="qwerty-3">&#125; </span>
        {"\n"}





   
    </code>
  </pre>        
</div>

<div>
  <h3 className="headings">Output</h3>
  <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
    <pre style={{ maxHeight: '500vh' }}>
      <code >
      {"\n"}
      <span className="qwerty-9">&nbsp; maximum = 65</span>
      {"\n"}
        </code>{"\n"}
        </pre>
  </div>
</div>


  <h1 className="mt-5">  </h1>
 
  <div className="back">
        <a href="/java-overriding">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-enum">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Jpassarg;